import { render, staticRenderFns } from "./roomPrice.vue?vue&type=template&id=9dd79f24&scoped=true&"
import script from "./roomPrice.vue?vue&type=script&lang=js&"
export * from "./roomPrice.vue?vue&type=script&lang=js&"
import style0 from "./roomPrice.vue?vue&type=style&index=0&id=9dd79f24&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dd79f24",
  null
  
)

export default component.exports